import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radarCloudsCloudsIcon",
  "use": "icon-radarCloudsCloudsIcon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-radarCloudsCloudsIcon\"><path clip-rule=\"evenodd\" d=\"M4.588 6.881a2.737 2.737 0 0 0 0 5.474h7.526a2.737 2.737 0 0 0 .001-5.473 3.763 3.763 0 0 0-7.527 0Z\" stroke=\"#4C556C\" stroke-width=\"1.444\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol